import React from "react";

const COLORS = ["#002FA7", "#FF2A00", "#0A8F5A", "#E08A00", "#7C3AED", "#0891B2", "#DB2777"];
const W = 1600, H = 1100, CX = 800, CY = 550;

const wrap = (text, max) => {
  const lines = [];
  let cur = "";
  for (const w of String(text).split(/\s+/)) {
    if ((cur + " " + w).trim().length > max && cur) { lines.push(cur); cur = w; } else cur = (cur + " " + w).trim();
  }
  return cur ? [...lines, cur] : lines;
};

const Lines = ({ x, y, lines, lh, ...rest }) => (
  <text x={x} y={y - ((lines.length - 1) * lh) / 2} {...rest}>
    {lines.map((l, i) => <tspan key={i} x={x} dy={i ? lh : 0}>{l}</tspan>)}
  </text>
);

function Branch({ b, i, n }) {
  const a = -Math.PI / 2 + (2 * Math.PI * i) / n;
  const c = COLORS[i % COLORS.length];
  const bx = CX + 300 * Math.cos(a), by = CY + 230 * Math.sin(a);
  const ix = CX + 490 * Math.cos(a), iy = CY + 325 * Math.sin(a);
  const items = b.items.map((t) => wrap(t, 26));
  const boxH = items.reduce((s, l) => s + l.length * 22 + 10, 14);
  const side = Math.cos(a) > 0.25 ? "r" : Math.cos(a) < -0.25 ? "l" : "c";
  const boxX = side === "r" ? ix - 40 : side === "l" ? ix - 230 : ix - 135;
  const boxY = side === "c" ? (Math.sin(a) < 0 ? iy - boxH - 10 : iy + 10) : iy - boxH / 2;
  let y = boxY + 26;
  return (
    <g>
      <line x1={CX} y1={CY} x2={bx} y2={by} stroke={c} strokeWidth="7" strokeLinecap="round" />
      <line x1={bx} y1={by} x2={boxX + 135} y2={boxY + boxH / 2} stroke={c} strokeWidth="2.5" strokeDasharray="6 6" />
      <rect x={boxX} y={boxY} width="270" height={boxH} rx="16" fill="#fff" stroke={c} strokeWidth="2.5" />
      {items.map((lines, k) => {
        const el = (
          <g key={k}>
            <circle cx={boxX + 18} cy={y - 6} r="5" fill={c} />
            <text x={boxX + 32} y={y} fontSize="18" fill="#0D0D0D" fontFamily="IBM Plex Sans, Arial, sans-serif">
              {lines.map((l, j) => <tspan key={j} x={boxX + 32} dy={j ? 22 : 0}>{l}</tspan>)}
            </text>
          </g>
        );
        y += lines.length * 22 + 10;
        return el;
      })}
      <ellipse cx={bx} cy={by} rx="120" ry="46" fill={c} />
      <Lines x={bx} y={by + 7} lines={wrap(b.title, 16)} lh={22} fontSize="21" fontWeight="800" fill="#fff" textAnchor="middle" fontFamily="Outfit, Arial, sans-serif" />
    </g>
  );
}

export const MindmapSvg = React.forwardRef(({ data }, ref) => (
  <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${W} ${H}`} className="w-full h-auto bg-white" data-testid="mindmap-svg">
    <rect width={W} height={H} fill="#fff" />
    {data.branches.map((b, i) => <Branch key={i} b={b} i={i} n={data.branches.length} />)}
    <ellipse cx={CX} cy={CY} rx="160" ry="70" fill="#0D0D0D" />
    <Lines x={CX} y={CY + 9} lines={wrap(data.center, 18)} lh={28} fontSize="27" fontWeight="900" fill="#fff" textAnchor="middle" fontFamily="Outfit, Arial, sans-serif" />
    <text x={W - 30} y={H - 24} fontSize="18" fill="#9CA3AF" textAnchor="end" fontFamily="Arial, sans-serif">{document.documentElement.lang === "en" ? "Mind map" : "Carte mentale"} · sux1.app</text>
  </svg>
));

export default MindmapSvg;
